import React, { useState } from 'react'
import loaderService from '../../service/loaderService';
import { axiosInstance } from '../../config/axiosConfig';
import { GET_TEMPLATE_BY_USERID } from '../../config/endpoint';
import { useEffect } from 'react';
import TemplateUploadModal from '../../components/TemplateUploadModal/TemplateUploadModal';

const MyData = () => {
    const [templates, setTemplates] = useState([])
    const [showModal, setShowModal] = useState(false)
    useEffect(() => {
        getTemplateData()
    }, [])
    const getTemplateData = () => {
        loaderService.show();
        axiosInstance.get(GET_TEMPLATE_BY_USERID).then((response) => {
            setTemplates(response.templates || []);
        }).catch((error) => {
            console.error('Error fetching file upload details:', error);
        }).finally(() => {
            loaderService.hide();
        });
    }
    const OpenUploadModal = () => {
        setShowModal(true)
    }
    return (
        <>
            <div className='myData w-100'>
                <h1 className="large-heading">My Data</h1>
                <div className='common-card '>
                    <div className='d-flex justify-content-between'>
                        <p className='font-22'>Uploaded File details</p>
                        <button className='theme-sky-btn' onClick={OpenUploadModal}>Add</button>
                    </div>
                    <div className='d-flex flex-column gap-16 overflow-auto' style={{ maxHeight: '300px' }}>
                        <table className='common-table'>
                            <thead>
                                <tr>
                                    <th>File Name</th>
                                    <th>Uploaded At</th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    templates?.map((file, index) => {
                                        return <tr key={index}>
                                            <td>{file.FileName}</td>
                                            <td>{file.CreatedDate ? new Date(file.CreatedDate).toLocaleString() : ''}</td>
                                        </tr>
                                    })
                                }
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            <TemplateUploadModal show={showModal} setShow={setShowModal} callback={getTemplateData} />
        </>
    )
}

export default MyData
